// extracted by mini-css-extract-plugin
module.exports = {"column":"_32bfde56","title":"_db901580","list":"_51a9f762"};